import React, { useState, useEffect } from 'react';
import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { moneyFormatter } from '../../helper';
import { useSelector } from 'react-redux';
import { title } from '../../constant/title';

HighchartsMore(Highcharts);

const LineChart = ({ data }) => {
  const options = {
    chart: {
      renderTo: 'chart4',
      height: 320,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: `Grafik ${title(data.metric)}`,
    },
    xAxis: {
      title: 'Waktu',
      tickInterval: 1,
      labels: {
        formatter: function () {
          return this.value + ' Bulan';
        },
      },
    },
    plotOptions: {
      series: { pointStart: 1 },
      yAxis: 1,
    },
    yAxis: {
      title: 'Harga Kendaraan',
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    tooltip: {
      shared: false,
      useHTML: true,
      formatter: function () {
        return (
          `<span style="font-size:12px; font-weight: bold">${this.x} Bulan</span><table>` +
          `<tr style="font-size: 14px">
                    <td style="padding:0">Harga</td>
                    <td style="padding:0px 5px;">:` +
          moneyFormatter(this.y) +
          `</td>
                </tr></table>`
        );
      },
    },
    series: [...data.result],
    responsive: [],
    credits: { enabled: false },
  };

  return (
    <div id="chart4">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default LineChart;
